import { render, staticRenderFns } from "./dietary.vue?vue&type=template&id=565cc4f7&scoped=true&"
import script from "./dietary.vue?vue&type=script&lang=js&"
export * from "./dietary.vue?vue&type=script&lang=js&"
import style0 from "./dietary.vue?vue&type=style&index=0&id=565cc4f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cc4f7",
  null
  
)

export default component.exports